import React, { useEffect, useState } from "react";
import "../../index.css";
import downArrow from "../../../../assets/design-revamp-product/product-icons/product-arrow.svg";

const ProductSubgroupDropdown = ({ subgroups, onClick }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(false);

  useEffect(() => {
    onClick(selectedItem);
  }, [selectedItem, onClick]);

  // Get visible items while preserving full object data
  const visibleItems = isExpanded ? subgroups : subgroups?.slice(0, 4);

  return (
    <div className="px-1" style={{ minWidth: "max-content" }}>
      <div
        className="product-dropdown-top"
        onClick={() => setOpenDropdown(!openDropdown)}
      >
        <h3
          style={{
            fontSize: "14px",
            width: "85%",
            whiteSpace: "nowrap",
            marginRight: "10px",
          }}
        >
          Category
        </h3>
        <img src={downArrow} width={15} height={15} alt="Down Arrow Dropdown" />
      </div>
      {openDropdown && (
        <div className="product-dropdown-body">
          <div>
            {visibleItems?.map((item, index) => (
              <div
                key={item.id || index}
                onClick={() => setSelectedItem(item)}
                className="product-dropdown-items"
              >
                <span className="text-sm">{item.name}</span>
              </div>
            ))}
          </div>

          {subgroups?.length > 4 && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="mt-2 product-dropdown-select-more"
            >
              <img
                src={downArrow}
                alt="Down Arrow Dropdown"
                width={15}
                height={15}
              />
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ProductSubgroupDropdown;
